import { makeAutoObservable, onBecomeObserved, runInAction } from 'mobx';
import { v4 as UUID } from 'uuid';
import { MindfulnessProgramTemplateDayUnit, createMindfulnessProgramTemplateDayUnit } from './MindfulnessProgramTemplateDayUnit';
import { MindfulnessProgramTemplateDayUnitVideo, createMindfulnessProgramTemplateDayUnitVideo } from './MindfulnessProgramTemplateDayUnitVideo';
import { ActivityApi } from '../../../Activity/Activity';

/**
 * Created by neo on 12.04.22.
 */

export type MindfulnessProgramTemplateDayUnitVideoSeries = MindfulnessProgramTemplateDayUnit & {
  videos: MindfulnessProgramTemplateDayUnitVideo[];
};

export function createMindfulnessProgramTemplateDayUnitVideoSeries(json?: Partial<MindfulnessProgramTemplateDayUnitVideoSeries>): MindfulnessProgramTemplateDayUnitVideoSeries {
  const base = createMindfulnessProgramTemplateDayUnit({ ...json, type: 'videoSeries' } as any);
  const unit: MindfulnessProgramTemplateDayUnitVideoSeries = makeAutoObservable({
    ...base,
    videos: (json?.videos ?? []).map((a: any) => createMindfulnessProgramTemplateDayUnitVideo(a)),

    toJS(newId: boolean = false) {
      return {
        ...(function() { const { id, createdAt, updatedAt, createdBy, updatedBy, name, description } = base; return { id: newId ? UUID() : id, createdAt, updatedAt, createdBy, updatedBy, name, description }; })(),
        videos: this.videos.map((a) => a),
      };
    },
  });

  onBecomeObserved(unit, 'activity', () => {
    if (!unit.activity) {
      ActivityApi.get(unit.activityIdentifier).then((result) => runInAction(() => (unit.activity = result)));
    }
  });

  return unit;
}
